<div class="waste-Reduction-table-wrap">
  <table aria-label="waste-Reduction-table" class="waste-Reduction-table">
    <thead>
      <tr>
        <th scope="col" rowspan="2">{{'Material' | translate}}</th>
        <th *ngIf="!activity.hideSubBar" scope="col" colspan="8">{{'ManagementPractice' | translate}}</th>
      </tr>
      <tr>
        <ng-container *ngFor="let rowHeaderName of managementPracticeType">
          <th scope="col">{{rowHeaderName | translate}}</th>
        </ng-container>
        <th scope="col">{{'TotalGeneratedTons' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let material of materialList; index as matInd">
        <tr user-list-item [materialName]="material" [material]="wasteReductionobj.materialTypes[material]"
          [materialFormGroup]="wasteFormGroup.get('metrialGroupList')['controls'][matInd]">
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
<div class="sub-total">
  <p class="total-label">{{'SubtotalLabel' | translate}}</p>
  <p class="total-value">{{tableLevelReportCtl.value}} MTCO2e</p>
</div>
<ng-container *ngIf="wasteFormGroup && wasteFormGroup.touched">
  {{updateActivityStatus()}}
</ng-container>